import api from './axios'
import { authHeader } from '../helpers'
import { authService } from './authentication.service'

export const acquisitionService = {
    createConfigAcquisition,
    getConfigAcquisition,
    getAllConfigAcquisitions,
    getConfigAcquisitionsByUtam,
    getSourceAcquisition,
    getAllSourcesAcquisition,
    updateConfigAcquisition,
    deleteConfigAcquisition
}

function getConfigAcquisition(id) {
    return api.get(`/Acquisition/${id}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse)
}

function getAllConfigAcquisitions() {
    return api.get('/Acquisitions', {
        headers: authHeader()
    })
        .then(authService.handleResponse)
}

function getConfigAcquisitionsByUtam(utam) {
    return api.get(`/Acquisitions/${utam}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse)
}

function getSourceAcquisition(id) {
    return api.get(`/Acquisition/Source/${id}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse)
}

function getAllSourcesAcquisition() {
    return api.get('/Acquisition/Sources', {
        headers: authHeader()
    })
        .then(authService.handleResponse)
}

function updateConfigAcquisition(configAcquisition) {
    return api.patch('/Acquisition', configAcquisition, {
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json'
        }
    })
        .then(authService.handleResponse)
}

function createConfigAcquisition(configAcquisition) {
    return api.post('/Acquisition', configAcquisition, {
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json'
        }
    })
        .then(authService.handleResponse)
}

function deleteConfigAcquisition(id) {
    return api.delete(`/Acquisition/${id}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse)
}
